import script from "./GanttChartView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GanttChartView.vue?vue&type=script&setup=true&lang=ts"

import "./GanttChartView.vue?vue&type=style&index=0&id=3a633774&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a633774"]])

export default __exports__